module.exports = __webpack_public_path__ + "img/baidu.fff38c65.png";